import { useEffect } from 'react';
import { useAxios } from 'src/hooks/use-axios';
import { RemitReportingSubscriptionInfo } from 'src/types/remit-reporting';
import { handleRequestError } from 'src/utils/axios-config';

type ReportingSubscriptionTradeType = 'PRIMARY' | 'SECONDARY';

export function useRemitReportingSubscriptionInfo(
  tradeType: ReportingSubscriptionTradeType
) {
  const subscriptionInfo = useAxios(
    (axios, signal) =>
      axios.request<RemitReportingSubscriptionInfo>({
        signal,
        url: `${
          PRISMA_CONFIG.remitReporting
        }/api/platform/remit-reporting-settings/${tradeType.toLowerCase()}`,
        method: 'GET',
        timeout: 5000,
      }),
    {
      neededOnPageLoad: false,
      onError(error) {
        const [_, report] = handleRequestError(error, () => {});

        if (report) reportError(error);

        return error;
      },
      cacheKey: `RemitReportingSubscriptionInfo-${tradeType}`,
    }
  );

  const { execute, setResponse, refresh, ...restSubscriptionInfo } =
    subscriptionInfo;

  useEffect(() => {
    if (PRISMA_CONFIG.remitReporting != null) execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (PRISMA_CONFIG.remitReporting == null) return;

  return restSubscriptionInfo;
}

export type RemitReportingSubscriptionInfoRequest = ReturnType<
  typeof useRemitReportingSubscriptionInfo
>;

export const remitReportingSubscriptionInfoLoading = (
  infoRequest: RemitReportingSubscriptionInfoRequest
) => infoRequest && !infoRequest.loaded;

export const isRemitReportingSubscriptionInfoLoaded = (
  infoRequest: RemitReportingSubscriptionInfoRequest
) => !!infoRequest?.response?.data;

export const isRemitReportingSubscriptionActive = (
  infoRequest: RemitReportingSubscriptionInfoRequest
) => infoRequest?.response?.data.active;
